import { LOAD_MANAGE_PAYMENT_OPTIONS_PAGE, SAVE_SUSPEND_PREPAY_OPTIONS, UPDATE_ACCOUNT_PAYMENT_OPTIONS } from 'constants/ActionTypes';
import { all, takeLatest } from 'lib/redux';
import { loadManagePaymentOptionsSaga, saveManagePaymentOptionsSaga, updateAccountPaymentOptionsSaga } from './ManagePaymentOptions.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_MANAGE_PAYMENT_OPTIONS_PAGE, loadManagePaymentOptionsSaga),
    takeLatest(SAVE_SUSPEND_PREPAY_OPTIONS, saveManagePaymentOptionsSaga),
    takeLatest(UPDATE_ACCOUNT_PAYMENT_OPTIONS, updateAccountPaymentOptionsSaga),
  ]);
}
